const indexItems = [
  { title: '古装仙侠', count: 326, icon: 'ri-sword-line', color: 'bg-primary-100 text-primary-700' },
  { title: '都市言情', count: 258, icon: 'ri-heart-line', color: 'bg-accent-100 text-accent-800' },
  { title: '悬疑探案', count: 189, icon: 'ri-search-eye-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '青春校园', count: 142, icon: 'ri-book-open-line', color: 'bg-primary-100 text-primary-700' },
  { title: '谍战军旅', count: 115, icon: 'ri-shield-line', color: 'bg-accent-100 text-accent-800' },
  { title: '喜剧搞笑', count: 98, icon: 'ri-emotion-laugh-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '科幻奇幻', count: 76, icon: 'ri-rocket-line', color: 'bg-primary-100 text-primary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          剧集分类
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          按类型快速找到你想看的
        </p>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color} transition-transform group-hover:scale-110`}>
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-800">{item.title}</span>
              <span className="text-xs text-foreground-400">{item.count} 部</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}